import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
    ajax, loadPickUpAddress, setEmptyStrings, loadUserSettings, postUserSettings,
    showAlertPopup, checkUserSettingsEmail, deletePickUpAddress, showPopup, getNavigation, downloadFile, deleteRecipientAddress, loadAutocompleteCountries, autoCompleteForeignCitiesForCountry
} from '../components/globals';
import { Languages } from '../components/languages';

import {
    InputColumn,
    ULinkFlat
} from '../components/utilities';

import {
    numberValidation,  emailValidation, emptyValidation, phoneValidation,
    validate
} from '../components/validate';

import { FieldProps } from '../components/fieldProps';
import { PageTitle, UIPopup, UIInput, UIButton, UIButtonPad, UISelect, UIMessageBox, UISummary, UISummaryWidgetBar, UIUpload, UIPagination, UIDownload } from '../components/guiElements';

import { findCountry, getCityName, getProvinceName, getZipCode, resetCityProvinceZipField, togglePropertyField } from '../helpers/helper';
import AddConfig from '../components/addConfig';


/* item, width, type, edit, data(name, surname, address, houseNo, zip, city, province, nation), editClick
*/
class UPlace extends React.Component {
    constructor(props) {
        super(props);

        this.linkClick = this.linkClick.bind(this);
    }

    linkClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.editClick(ev, this.props.item);
    }

    render() {
        const data = this.props.data;
        return (
            <div>
                <div>{data.name + " " + data.surname}</div>
                <div>{data.address + " " + data.houseNo + ", " + data.zip}</div>
                <div>{data.city + ", " + data.province}</div>
                <div>{data.nation}</div>
                <div>{data.email + ", " + data.phone}</div>
            </div>
        );
    }
}

/* title, description, children
*/
class SettingsBasePage extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        //#endregion Methods binding

        this.state = {
        };
    }

    //#region Events


    //#endregion Events

    render() {
        //#region Data Structures
        //#endregion Data Structures

        return <div className="page-content settings-base-page">
            <div className="widget">
                <div className="widget-header">
                    {this.props.title}
                </div>
                <div className="widget-content">
                    {this.props.children}
                </div>
            </div>
        </div>;
    }
}


export class Company extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        this.dataChange = this.dataChange.bind(this);
        this.actionClick = this.actionClick.bind(this);
        //#endregion Methods binding
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.getSection('Company');

        this.state = {
            data: props.data
        };
    }

    //#region Events

    componentDidMount() {
        ajax(this, { method: 'get', url: '/api/organization/company-setts', headers: { Authorization: 'Bearer ' + this.uc?.jwtToken } },
            response => {
                this.setState({ data: response.data.result.companySettings });
            },
            error => {
                //this.props.popupErrorMessage("");
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[0].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                    </UIMessageBox>
                });
            }
        );
    }

    dataChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        const names = name.split('.');
        let newData = JSON.parse(JSON.stringify(this.state.data));
        newData[names[1]] = value;
        this.setState({ data: newData });
    }

    actionClick(ev) {
        ajax(this, { method: 'post', url: '/api/organization/company-setts', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: this.state.data },
            response => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[1].captions[0]} message={this.le.messages[1].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[1].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                    </UIMessageBox>
                });
            },
            error => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[0].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                    </UIMessageBox>
                });
            }
        );
    }
    //#endregion Events



    render() {
        const widgets = this.le.sections.map(el => {

            return <div key={uuidv4()}>
                    <div className="widget-content-title">{el.title}</div> {
                            el.inputs.map(itm => (
                                <UIInput key={el.id + "-" + itm.name} name={el.id + "." + itm.name} value={this.state.data[itm.name]} label={itm.text} onChange={this.dataChange} />
                            ), this)
                    }
                </div>;
        }, this);

        return <div className="page-company">
            <PageTitle icon="../images/mainMenu/Settings.png" title={Languages.getSection('Main').menuLabels.company} />
            <div className="page-content">
                <div className="widget">
                    <div className="widget-content">
                        <div>
                            {widgets}
                        </div>
                        <UIButtonPad align="right">
                            <UIButton className="confirm slim" text={this.le.buttons[0]} onClick={this.actionClick} />
                        </UIButtonPad>
                    </div>
                </div>
            </div>
            {this.state.messageBox}
        </div>;
    }
}

export class SenderAddresses extends React.Component {
    constructor(props) {
        super(props);

        this.addClick = this.addClick.bind(this);
        this.editClick = this.editClick.bind(this);
        this.deleteClick = this.deleteClick.bind(this);
        this.modalClick = this.modalClick.bind(this);
        this.modalChange = this.modalChange.bind(this);
        this.loadSenderAddresses = this.loadSenderAddresses.bind(this);

        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteCityChange = this.onAutocompleteCityChange.bind(this);
        this.onAutocompleteCitySelected = this.onAutocompleteCitySelected.bind(this);


        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.SenderAddresses[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
    
        this.state = {
            modalColumn: {
                id: 'C1',
                rowsize: 30,
                itemunit: 10,
                items: this.buildNewAddress()
            },
            places: [],
            modalType: 0,
            modalMsg: "",
            msgNumber: 0,
            modalData: this.buildAddress(),
            modalReference: null,
            countries: [],
            countryCode: "",
            suggestedCountry: [],
            suggestedCity:[],
            modal: null
        };
    }

    componentDidMount() {
        let navigation = getNavigation(this.loadSenderAddresses, this.leMain.navigation);
        this.loadSenderAddresses(navigation);
        this.setState({
            countries: [
                {
                    code: "IT",
                    eu: true,
                    idcountry: 1,
                    name: "ITALIA",
                    name_en: "ITALY",
                    visible_front: true
                }
            ]
        });

    }


    buildAddress() {
        return {
            id: null,
            type: '',
            name: '',
            surname: '',
            address: '',
            houseNo: '',
            nation: 'ITALIA',
            city: '',
            province: '',
            zip: '',
            phone: '',
            email: ''
        }
    }

    buildNewAddress() {
        return  [
            { id: 'name', size: 15, text: this.le.change.inputs[0], type: 'text', maxLength: FieldProps.getFieldProp('name', 'maxLength'), class: null, mandatory: true, value: '',validate: emptyValidation  },
            { id: 'surname', size: 15, text: this.le.change.inputs[1], type: 'text', maxLength: FieldProps.getFieldProp('surname', 'maxLength'), class: null, mandatory: false, value: '' },
            { id: 'address', size: 20, text: this.le.change.inputs[2], type: 'text', maxLength: FieldProps.getFieldProp('address', 'maxLength'), class: null, mandatory: true, value: '',validate: emptyValidation },
            { id: 'houseNo', size: 10, text: this.le.change.inputs[3], type: 'text', maxLength: FieldProps.getFieldProp('houseNo', 'maxLength'), class: null, mandatory: false, value: '' },
            { 
                id: 'nation', 
                type: 'selectField',
                size: 30,
                mandatory: true,
                text: this.le.change.inputs[4],
                maxLength: FieldProps.getFieldProp('nation', 'maxLength'),
                class: null,
                options: [],
                value: 'ITALIA',
                validate: emptyValidation
            },
            { 
                id: 'city',
                type: 'autocomplete',
                size: 30,
                mandatory: true,
                text: this.le.change.inputs[5],
                maxLength: FieldProps.getFieldProp('city', 'maxLength'),
                class: null,
                validate: emptyValidation,
                disabled: false,
                options: [],
            },
            { id: 'province', size: 20, text: this.le.change.inputs[6], type: 'text', maxLength: FieldProps.getFieldProp('province', 'maxLength'), class: null, mandatory: true, value: '', validate: emptyValidation, disabled: true, },
            { id: 'zip', size: 10, text: this.le.change.inputs[7], type: 'text', maxLength: FieldProps.getFieldProp('zip', 'maxLength'), class: null, mandatory: true, value: '', validate: emptyValidation, disabled: true },
            { id: 'email', size: 20, text: this.le.change.inputs[8], type: 'text', maxLength: FieldProps.getFieldProp('email', 'maxLength'), class: null, mandatory: true, value: '', validate: emailValidation },
            { id: 'phone', size: 10, text: this.le.change.inputs[9], type: 'text', maxLength: FieldProps.getFieldProp('phone', 'maxLength'), class: null, mandatory: true, value: '', validate: phoneValidation }
        ]
    }


    validate(items) {
        let validation = [];
        for (let i = 0; i < items.length; i++) {
            let el = items[i];
            if (el.hasOwnProperty("validate") && el.mandatory) {
                validation.push({
                    fieldObject: el,
                    fieldName: el.id,
                    fieldValue: el.value,
                    fieldError: 'error',
                    validate: el.validate
                });
            }
        }
        return validate(validation);
    }

    saveAddress(modalData, ok, ko) {
        ajax(this, { method: 'post', url: '/api/organization/pickup-address', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: modalData },
            response => {
                ok(response.data.result.address);
            },
            error => { ko(); }
        );
    }

    loadSenderAddresses(navigation) {
        const url = '/api/organization/pickup-address/' + navigation.pageNo.value + '/' + navigation.pageSize.value;
            ajax(this, { method: 'get', url,  headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {
                    const addresses = response.data.result.address
                    navigation.totalItems.value = response.data.result.totItems;
                    this.setState({ 
                        navigation: navigation,
                        places: addresses,
                    });
                },
            error => {  }
        );
    }

    findActiveOrders(places, id) {
        const findCurrentPlace = places.find((place) => place.id === id);
        return {
            haveActiveOrders: findCurrentPlace.activeOders.length > 0,
            activeOrders: findCurrentPlace.activeOders
        }

    }


    addClick(ev) {
        this.setState({
             modalTarget: 'address',
             modalData: this.buildAddress(),
             modalColumn: {
                items: this.buildNewAddress()
            }
            });
    }

    editClick(ev, id) {
        let senderAddress = this.state.places.find(el => el.id == id);
        const newItems = this.state.modalColumn.items.map((item) => {
            return {
                ...item,
                value: senderAddress[item.id]
            }
        });
        const item = {
            cityName:  senderAddress.city,
            provinceCode: senderAddress.province,
            zipCode: senderAddress.zip
        }

        this.checkForMandatoryFields(newItems, item);

        if (senderAddress != null) {
            this.setState((prevState) => {
                return {
                    modalTarget: 'address',
                    modalData: {...senderAddress},
                    modalReference: id,
                    modalColumn: {
                        ...prevState.modalColumn,
                        items: newItems
                    }
                }
            });
        }
    }


    deleteClick(ev, id) {
        const places = this.state.places;
        const {haveActiveOrders, activeOrders} =  this.findActiveOrders(places, id);

        let buttons = [
            <UIButton key={uuidv4()}
                className = "confirm"
                text={this.le.popup.activeOrderModal.confirmText}
                onClick = {(ev) =>  this.setState({ modal: null })} />,
            ];

        if(haveActiveOrders) {
            this.setState({
                modal: <UIPopup title={this.le.popup.activeOrderModal.title} buttons={buttons} onCancel={((ev) =>  this.setState({ modal: null }))}>
                    <div className="">
                        {activeOrders.map((order, index) => (<span key={index}>{order} <br /></span>))}
                    </div>
                </UIPopup>
            });
            return;
        }

        deletePickUpAddress(id, this.uc.jwtToken,
            () => {
                let newAddresses = this.state.places.filter(el => el.id !== id);
                this.setState({ places: [...newAddresses] });
            },
            ko => {
            },
        this);
    }

    uploadCsvFile(typeCsv,data, ok, ko) {
        const formData = new FormData();
        formData.append("File", data);
        ajax(this, { method: 'post', url: '/api/organization/address-file/' + typeCsv, headers: { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + this.uc.jwtToken }, data: formData },
            response => {
                console.log(response, "response")
                ok.call(this);
            },
            error => {
                ko.call(this, error);
            }
        );
    }


    actionClick(ev, name, target) {
        try {
            if (name === 'uploadCSV') {
                this.props.loaderShow(0);
                const file = ev.target.files[0];
                this.uploadCsvFile(target,file,
                    () => {
                        this.props.loaderHide();
                        const msg = this.le.message.csvUploaded;
                        const self = this;
                        const exitPopup = function () {
                            self.loadSenderAddresses(self.state.navigation);
                        }

                        let obj = {
                            title: msg.captions[0],
                            width: "35%",
                            icon: "info",
                            messages: msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                        };
                        this.props.popupMessage(obj);
                       
                    },
                    (e) => {
                        this.props.loaderHide();
                        const msg = this.le.message.csvUploaded.errors.messages;
                        // this.props.popupErrorMessage(msg.messages);
                        this.props.popupErrorMessage(msg);

                    });
            } else if (name == 'downloadCSV') {
                downloadFile('api/filemanager/file/bookAddressTemplate', this.uc.jwtToken, error => { }, this);
            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    modalChange(ev, who, val, fieldName) {
        const modalItems = this.state.modalColumn.items
        modalItems.forEach(item => {
            if(item.id === fieldName) {
                item.value = val;
            }
        });

        let modalData = this.state.modalData;
        modalData[fieldName] = val;

        this.setState((prevState) => {
            return {
                modalColumn: {
                    ...prevState.modalColumn,
                    modalData,
                    items: modalItems
                }
            }
        });
    }
    
    modalClick(ev, action) {
        if (action) {
            let newData = this.state.modalData;

            let modalData = this.state.modalColumn.items;
            if (!this.validate(modalData)) {
                this.setState({ modalColumn: this.state.modalColumn });
                return;
            }

            this.saveAddress(newData,
                id => {
                    newData.id = id;
                    let places = this.state.places;

                    let index = places.findIndex(el => el.id == id);

                    if (index >= 0) {
                        places[index] = newData;
                    } else {
                        places.push(newData);
                    }
                    this.setState({ modalTarget: null, places: places });
                },
                ko => {
                    this.setState({
                        messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                            <UIButton className="confirm" text={this.le.messages[0].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                        </UIMessageBox>
                    });
                }
            )
        } else{
            
            this.setState({
                modalTarget: null,
                modalColumn: {
                    items: this.buildNewAddress()
                }});
        }
    }

    checkForMandatoryFields(items, item) {
        if(!getProvinceName(item)) {
            togglePropertyField({
              items,
              fieldName: 'province',
              booleanValue: false,
              propertyName: "mandatory" 
            });
          } else {
              togglePropertyField({
                  items,
                  fieldName: 'province',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
  
          if(!getZipCode(item)) {
              togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: false,
                  propertyName: "mandatory" 
              });
            } else {
              togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
    }

    onAutocompleteCountryChange(who, value, countryCode) {

        let newData = {...this.state.modalColumn};
        newData.items[who[1]].value = value;
        const items = newData.items;

        const foundCountry = findCountry(value, this.state.countries);
        const suggestedCountry = foundCountry;
        
        resetCityProvinceZipField(items);

        this.setState({
            suggestedCountry : suggestedCountry,
            countryCode: countryCode,
            modalColumn: newData,
            suggestedCity: []
        });
        
    }

    onAutocompleteCityChange(who,  value ) {
        let newData = {...this.state.modalColumn};
        newData.items[who[1]].value = value;
        let countryCode = this.state.countryCode;

        let modalData = this.state.modalData;
        modalData['city'] = value;

        if(countryCode.length === 0) {
            const countryName = newData.items[4].value
            const country = findCountry(countryName, this.state.countries);
            countryCode = country[0]?.countryCode;
        }

        let suggested = [];
        if (value.length >= 3 && countryCode) {
            (autoCompleteForeignCitiesForCountry(this.uc.jwtToken, value,
                countryCode,
                response => {
                    response.forEach((el) => {
                        suggested.push({
                            id: el.id,
                            label: el.label,
                            labelShort:el.labelShort, 
                            cityName: el.cityName,
                            provinceCode: el.provinceCode,
                            zipCode: el.value
                        }); 
                    });
                    this.setState(prevState => {
                        let prevSuggestedCity = [...prevState.suggestedCity];
                        prevSuggestedCity = suggested;
                        return  { 
                            modalColumn: newData,
                            suggestedCity: prevSuggestedCity,
                            modalData
                        }
                    })

                }));
        } 
        
        else {
            this.setState({ modalColumn: newData, suggestedCity: [] });
        }
    }


    onAutocompleteCitySelected(who, item) {
        let newData = {...this.state.modalColumn};
        const items = newData.items;

        let modalData = this.state.modalData;
       
        items.forEach((fieldObject => {
            if (fieldObject.id === 'city') {
                fieldObject.value = getCityName(item);
                modalData['city'] = getCityName(item)
            } else if (fieldObject.id === 'province') {
                fieldObject.value = getProvinceName(item);
                modalData['province'] = getProvinceName(item)
            } else if (fieldObject.id === 'zip') {
                fieldObject.value = getZipCode(item);
                modalData['zip'] = getZipCode(item)
            }
        }));
        this.checkForMandatoryFields(items, item);
        this.setState({ modalColumn: {...newData, items: items}, modalData });
    }
    
    render() {
        const rows = this.state.places.map(itm => (
            [<div className="entry-list-row-panel" key={"pan-1-" + itm.id}>
                
                <div className="entry-list-text">
                    <UPlace item={itm.id} type={itm.type} edit={this.le.sections[0].edit} editClick={this.editClick} data={itm} />
                </div>
            </div>,
                <div className="entry-list-row-panel" key={"pan-2-" + itm.id}>
            </div>,
                <div className="entry-list-row-panel" key={"pan-3-" + itm.id}>
                    <div className="entry-list-text" style={{marginLeft: "auto"}}>{this.le.sections[0].active}</div>

                    <UIButtonPad className="pt-0" align="right">
                        <UIButton className="modify" text={this.le.buttons[1]} onClick={(ev) => this.editClick(ev, itm.id)} />
                        <UIButton className="modify delete" text={this.le.buttons[2]} onClick={(ev) => this.deleteClick(ev, itm.id)} />
                    </UIButtonPad>
            </div>]

        ), this);

        let suggestedOptions = {...this.state.modalColumn};
            suggestedOptions.items[4].options = this.state.countries;   
            suggestedOptions.items[5].options = this.state.suggestedCity;

        let popup = null;
        if (this.state.modalTarget == 'address') {
            const le = this.le.change;
            popup = <UIPopup
                className="address"
                title={this.state.modalData.id ? le.title[1] : le.title[0]}
                onCancel={(ev) => this.modalClick(ev, false)}
                buttons={[
                    <UIButton key="btn-1" className="" text={le.btnCancel} onClick={(ev) => this.modalClick(ev, false)} />,
                    <UIButton key="btn-2" className="confirm" text={le.btnOk} onClick={(ev) => this.modalClick(ev, true)} />
                ]}>
                <div className="flex-panel">
                    <InputColumn 
                        column={this.state.modalReference}
                        data={this.state.modalColumn}
                        onChange={this.modalChange}
                        onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                        onAutocompleteChange={this.onAutocompleteCityChange}
                        onAutocompleteSelected={this.onAutocompleteCitySelected}
                        />
                </div>
            </UIPopup>;
        }

        return <div className="page-addresses">
            <PageTitle icon="../images/mainMenu/Settings.png" title={this.le.title} />
            <UISummary className="no-border">
                <div className="d-flex align-item-center">
                    <div className="file-transfer-panel">
                        <UIUpload key="uploadCsv" title={this.le.fileTemplates.csv[0]} onChange={ev => this.actionClick(ev,'uploadCSV','sender')}/>
                        <UIDownload key="downloadCSV" title={this.le.fileTemplates.csv[1]} onClick={ev => this.actionClick(ev, 'downloadCSV')} />
                    </div>
                    <UIButtonPad align="right">
                        <UIButton className="slim" text={this.le.sections[0].action} onClick={this.addClick} />
                    </UIButtonPad>
                </div>
            </UISummary>
            <div className="page-content">

                <div className="widget">
                    <div className="widget-content for-entry-list">
                        <div className="entry-list" key="list-1">
                            <div className="entry-list-row-panel entry-list-row-header" key="listh1">
                                <div>{this.le.sections[0].title}</div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" key="listh2">
                                <div></div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" key="listh3">
                                <div />
                                <div className=""></div>
                            </div>
                            {rows}
                        </div>
                        <UIPagination navigation={this.state.navigation} />
                    </div>
                </div>
            </div>
            {popup}
            {this.state.modal}
            {this.state.messageBox}
        </div>;


    }
}


export class RecipientAddresses extends React.Component {
    constructor(props) {
        super(props);

        this.addClick = this.addClick.bind(this);
        this.editClick = this.editClick.bind(this);
        this.deleteClick = this.deleteClick.bind(this);
        this.modalClick = this.modalClick.bind(this);
        this.modalChange = this.modalChange.bind(this);
        this.loadRecipientAddresses = this.loadRecipientAddresses.bind(this);

        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteCityChange = this.onAutocompleteCityChange.bind(this);
        this.onAutocompleteCitySelected = this.onAutocompleteCitySelected.bind(this);


        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.RecipientAddresses[Languages.selectedLanguage];
        this.leMain = Languages.Main[Languages.selectedLanguage];
    
        this.state = {
            modalColumn: {
                id: 'C1',
                rowsize: 30,
                itemunit: 10,
                items: this.buildNewAddress()
            },
            places: [],
            modalType: 0,
            modalMsg: "",
            msgNumber: 0,
            modalData: this.buildAddress(),
            modalReference: null,
            countries: [],
            countryCode: "",
            suggestedCountry: [],
            suggestedCity:[],
        };
    }

    componentDidMount() {
        let navigation = getNavigation(this.loadRecipientAddresses, this.leMain.navigation);
        this.loadRecipientAddresses(navigation);

        loadAutocompleteCountries(this.uc.jwtToken, (countries) => {
            this.setState({
                countries
            });
        },
        ko => { },
        this);
    }


    buildAddress() {
        return {
            id: null,
            type: '',
            name: '',
            surname: '',
            address: '',
            houseNo: '',
            nation: 'ITALIA',
            city: '',
            province: '',
            zip: '',
            phone: '',
            email: ''
        }
    }

    buildNewAddress() {
        return  [
            { id: 'name', size: 15, text: this.le.change.inputs[0], type: 'text', maxLength: FieldProps.getFieldProp('name', 'maxLength'), class: null, mandatory: true, value: '',validate: emptyValidation  },
            { id: 'surname', size: 15, text: this.le.change.inputs[1], type: 'text', maxLength: FieldProps.getFieldProp('surname', 'maxLength'), class: null, mandatory: false, value: '' },
            { id: 'address', size: 20, text: this.le.change.inputs[2], type: 'text', maxLength: FieldProps.getFieldProp('address', 'maxLength'), class: null, mandatory: true, value: '',validate: emptyValidation },
            { id: 'houseNo', size: 10, text: this.le.change.inputs[3], type: 'text', maxLength: FieldProps.getFieldProp('houseNo', 'maxLength'), class: null, mandatory: false, value: '' },
            { 
                id: 'nation', 
                type: 'selectField',
                size: 30,
                mandatory: true,
                text: this.le.change.inputs[4],
                maxLength: FieldProps.getFieldProp('nation', 'maxLength'),
                class: null,
                options: [],
                value: 'ITALIA',
                validate: emptyValidation
            },
            { 
                id: 'city',
                type: 'autocomplete',
                size: 30,
                mandatory: true,
                text: this.le.change.inputs[5],
                maxLength: FieldProps.getFieldProp('city', 'maxLength'),
                class: null,
                validate: emptyValidation,
                disabled: false,
                options: [],
            },
            { id: 'province', size: 20, text: this.le.change.inputs[6], type: 'text', maxLength: FieldProps.getFieldProp('province', 'maxLength'), class: null, mandatory: true, value: '', validate: emptyValidation, disabled: true, },
            { id: 'zip', size: 10, text: this.le.change.inputs[7], type: 'text', maxLength: FieldProps.getFieldProp('zip', 'maxLength'), class: null, mandatory: true, value: '', validate: emptyValidation, disabled: true },
            { id: 'email', size: 20, text: this.le.change.inputs[8], type: 'text', maxLength: FieldProps.getFieldProp('email', 'maxLength'), class: null, mandatory: true, value: '', validate: emailValidation },
            { id: 'phone', size: 10, text: this.le.change.inputs[9], type: 'text', maxLength: FieldProps.getFieldProp('phone', 'maxLength'), class: null, mandatory: true, value: '', validate: phoneValidation }
        ]
    }


    validate(items) {
        let validation = [];
        for (let i = 0; i < items.length; i++) {
            let el = items[i];
            if (el.hasOwnProperty("validate") && el.mandatory) {
                validation.push({
                    fieldObject: el,
                    fieldName: el.id,
                    fieldValue: el.value,
                    fieldError: 'error',
                    validate: el.validate
                });
            }
        }
        return validate(validation);
    }

    saveAddress(modalData, ok, ko) {
        ajax(this, { method: 'post', url: '/api/organization/recipient-address', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: modalData },
            response => {
                ok(response.data.result.recipient);
            },
            error => { ko(); }
        );
    }

    loadRecipientAddresses(navigation) {
        const url = '/api/organization/recipient-address/' + navigation.pageNo.value + '/' + navigation.pageSize.value;
            ajax(this, { method: 'get', url,  headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
                response => {
                    const addresses = response.data.result.address
                    navigation.totalItems.value = response.data.result.totItems;
                    this.setState({ 
                        navigation: navigation,
                        places: addresses,
                    });
                },
                error => {  }
            );
    }

   
    addClick(ev) {
        this.setState({
             modalTarget: 'address',
             modalData: this.buildAddress(),
             modalColumn: {
                items: this.buildNewAddress()
            }
            });
    }

    editClick(ev, id) {
        let recipientAddress = this.state.places.find(el => el.id == id);
        const newItems = this.state.modalColumn.items.map((item) => {
            return {
                ...item,
                value: recipientAddress[item.id]
            }
        });
        const item = {
            cityName:  recipientAddress.city,
            provinceCode: recipientAddress.province,
            zipCode: recipientAddress.zip
        }

        this.checkForMandatoryFields(newItems, item);

        if (recipientAddress != null) {
            this.setState((prevState) => {
                return {
                    modalTarget: 'address',
                    modalData: {...recipientAddress},
                    modalReference: id,
                    modalColumn: {
                        ...prevState.modalColumn,
                        items: newItems
                    }
                }
            });
        }
    }

    deleteClick(ev, id) {
        deleteRecipientAddress(id, this.uc.jwtToken,
            () => {
                let newAddresses = this.state.places.filter(el => el.id !== id);
                this.setState({ places: [...newAddresses] });
            },
            ko => {
            },
        this);
    }

    uploadCsvFile(typeCsv,data, ok, ko) {
        const formData = new FormData();
        formData.append("File", data);
        ajax(this, { method: 'post', url: '/api/organization/address-file/' + typeCsv, headers: { 'Content-Type': 'multipart/form-data', Authorization: 'Bearer ' + this.uc.jwtToken }, data: formData },
            response => {
                console.log(response, "response")
                ok.call(this);
            },
            error => {
                ko.call(this, error);
            }
        );
    }


    actionClick(ev, name, target) {
        try {
            if (name === 'uploadCSV') {
                this.props.loaderShow(0);
                const file = ev.target.files[0];
                this.uploadCsvFile(target,file,
                    () => {
                        this.props.loaderHide();
                        const msg = this.le.message.csvUploaded;
                        const self = this;
                        const exitPopup = function () {
                            self.loadRecipientAddresses(self.state.navigation);
                        }

                        let obj = {
                            title: msg.captions[0],
                            width: "35%",
                            icon: "info",
                            messages: msg.messages,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: exitPopup }]
                        };
                        this.props.popupMessage(obj);
                       
                    },
                    (e) => {
                        this.props.loaderHide();
                        const msg = this.le.message.csvUploaded.errors.messages;
                        // this.props.popupErrorMessage(msg.messages);
                        this.props.popupErrorMessage(msg);

                    });
            } else if (name == 'downloadCSV') {
                downloadFile('api/filemanager/file/bookAddressTemplate', this.uc.jwtToken, error => { }, this);
            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    modalChange(ev, who, val, fieldName) {
        const modalItems = this.state.modalColumn.items
        modalItems.forEach(item => {
            if(item.id === fieldName) {
                item.value = val;
            }
        });

        let modalData = this.state.modalData;
        modalData[fieldName] = val;

        this.setState((prevState) => {
            return {
                modalColumn: {
                    ...prevState.modalColumn,
                    modalData,
                    items: modalItems
                }
            }
        });
    }
    
    modalClick(ev, action) {
        if (action) {
            let newData = this.state.modalData;

            let modalData = this.state.modalColumn.items;
            if (!this.validate(modalData)) {
                this.setState({ modalColumn: this.state.modalColumn });
                return;
            }

            this.saveAddress(newData,
                id => {
                    newData.id = id;
                    let places = this.state.places;

                    let index = places.findIndex(el => el.id == id);

                    if (index >= 0) {
                        places[index] = newData;
                    } else {
                        places.push(newData);
                    }
                    this.setState({ modalTarget: null, places: places });
                },
                ko => {
                    this.setState({
                        messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                            <UIButton className="confirm" text={this.le.messages[0].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                        </UIMessageBox>
                    });
                }
            )
        } else{
            
            this.setState({
                modalTarget: null,
                modalColumn: {
                    items: this.buildNewAddress()
                }});
        }
    }

    checkForMandatoryFields(items, item) {
        if(!getProvinceName(item)) {
            togglePropertyField({
              items,
              fieldName: 'province',
              booleanValue: false,
              propertyName: "mandatory" 
            });
          } else {
              togglePropertyField({
                  items,
                  fieldName: 'province',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
  
          if(!getZipCode(item)) {
              togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: false,
                  propertyName: "mandatory" 
              });
            } else {
              togglePropertyField({
                  items,
                  fieldName: 'zip',
                  booleanValue: true,
                  propertyName: "mandatory" 
              });
          }
    }

    onAutocompleteCountryChange(who, value, countryCode) {

        let newData = {...this.state.modalColumn};
        newData.items[who[1]].value = value;

        let modalData = this.state.modalData;
        modalData['nation'] = value;

        const items = newData.items;

        const foundCountry = findCountry(value, this.state.countries);
        const suggestedCountry = foundCountry;
        
        resetCityProvinceZipField(items);

        this.setState({
            suggestedCountry : suggestedCountry,
            countryCode: countryCode,
            modalColumn: newData,
            suggestedCity: []
        });
        
    }

    onAutocompleteCityChange(who,  value ) {
        let newData = {...this.state.modalColumn};
        newData.items[who[1]].value = value;
        let countryCode = this.state.countryCode;

        let modalData = this.state.modalData;
        modalData['city'] = value;

        if(countryCode.length === 0) {
            const countryName = newData.items[4].value
            const country = findCountry(countryName, this.state.countries);
            countryCode = country[0]?.countryCode;
        }

        let suggested = [];
        if (value.length >= 3 && countryCode) {
            (autoCompleteForeignCitiesForCountry(this.uc.jwtToken, value,
                countryCode,
                response => {
                    response.forEach((el) => {
                        suggested.push({
                            id: el.id,
                            label: el.label,
                            labelShort:el.labelShort, 
                            cityName: el.cityName,
                            provinceCode: el.provinceCode,
                            zipCode: el.value
                        }); 
                    });
                    this.setState(prevState => {
                        let prevSuggestedCity = [...prevState.suggestedCity];
                        prevSuggestedCity = suggested;
                        return  { 
                            modalColumn: newData,
                            suggestedCity: prevSuggestedCity,
                            modalData
                        }
                    })

                }));
        } 
        
        else {
            this.setState({ modalColumn: newData, suggestedCity: [] });
        }
    }


    onAutocompleteCitySelected(who, item) {
        let newData = {...this.state.modalColumn};
        const items = newData.items;

        let modalData = this.state.modalData;
       
        items.forEach((fieldObject => {
            if (fieldObject.id === 'city') {
                fieldObject.value = getCityName(item);
                modalData['city'] = getCityName(item)
            } else if (fieldObject.id === 'province') {
                fieldObject.value = getProvinceName(item);
                modalData['province'] = getProvinceName(item)
            } else if (fieldObject.id === 'zip') {
                fieldObject.value = getZipCode(item);
                modalData['zip'] = getZipCode(item)
            }
        }));
        this.checkForMandatoryFields(items, item);
        this.setState({ modalColumn: {...newData, items: items}, modalData });
    }

    render() {
        const rows = this.state.places.map(itm => (
            [<div className="entry-list-row-panel" key={"pan-1-" + itm.id}>
                
                <div className="entry-list-text">
                    <UPlace item={itm.id} type={itm.type} edit={this.le.sections[0].edit} editClick={this.editClick} data={itm} />
                </div>
            </div>,
                <div className="entry-list-row-panel" key={"pan-2-" + itm.id}>
            </div>,
                <div className="entry-list-row-panel" key={"pan-3-" + itm.id}>
                    <div className="entry-list-text" style={{marginLeft: "auto"}}>{this.le.sections[0].active}</div>

                    <UIButtonPad className="pt-0" align="right">
                        <UIButton className="modify" text={this.le.buttons[1]} onClick={(ev) => this.editClick(ev, itm.id)} />
                        <UIButton className="modify delete" text={this.le.buttons[2]} onClick={(ev) => this.deleteClick(ev, itm.id)} />
                    </UIButtonPad>
            </div>]

        ), this);

        let suggestedOptions = {...this.state.modalColumn};
        suggestedOptions.items[4].options = this.state.countries;   
        suggestedOptions.items[5].options = this.state.suggestedCity;

        let popup = null;
        if (this.state.modalTarget == 'address') {
            const le = this.le.change;

            popup = <UIPopup
                className="address"
                title={this.state.modalData.id ? le.title[1] : le.title[0]}
                onCancel={(ev) => this.modalClick(ev, false)}
                buttons={[
                    <UIButton key="btn-1" className="" text={le.btnCancel} onClick={(ev) => this.modalClick(ev, false)} />,
                    <UIButton key="btn-2" className="confirm" text={le.btnOk} onClick={(ev) => this.modalClick(ev, true)} />
                ]}>
                <div className="flex-panel">
                    <InputColumn 
                        column={this.state.modalReference}
                        data={this.state.modalColumn}
                        onChange={this.modalChange}
                        onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                        onAutocompleteChange={this.onAutocompleteCityChange}
                        onAutocompleteSelected={this.onAutocompleteCitySelected}
                        />
                </div>
            </UIPopup>;
        }

        return <div className="page-addresses">
            <PageTitle icon="../images/mainMenu/Settings.png" title={this.le.title} />
            <UISummary className="no-border">
                <div className="d-flex align-item-center">
                    <div className="file-transfer-panel">
                        <UIUpload key="uploadCsv" title={this.le.fileTemplates.csv[0]} onChange={ev => this.actionClick(ev,'uploadCSV','recipient')}/>
                        <UIDownload key="downloadCSV" title={this.le.fileTemplates.csv[1]} onClick={ev => this.actionClick(ev, 'downloadCSV')} />
                    </div>
                    <UIButtonPad align="right">
                        <UIButton className="slim" text={this.le.sections[0].action} onClick={this.addClick} />
                    </UIButtonPad>
                </div>
            </UISummary>
            <div className="page-content">

                <div className="widget">
                    <div className="widget-content for-entry-list">
                        <div className="entry-list" key="list-1">
                            <div className="entry-list-row-panel entry-list-row-header" key="listh1">
                                <div>{this.le.sections[0].title}</div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" key="listh2">
                                <div></div>
                            </div>
                            <div className="entry-list-row-panel entry-list-row-header" key="listh3">
                                <div />
                                <div className=""></div>
                            </div>
                            {rows}
                        </div>
                        <UIPagination navigation={this.state.navigation} />
                    </div>
                </div>
            </div>
            {popup}
            {this.state.messageBox}
        </div>;
    }
}

export class Labels extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        this.dataChange = this.dataChange.bind(this);
        this.actionClick = this.actionClick.bind(this);
        //this.closeModal = this.closeModal.bind(this);
        //#endregion Methods binding
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.Labels[Languages.selectedLanguage];

        this.labelFormats = [
            { value: "pdf", text: "PDF" },
            { value: "prn", text: "ZEBRA" }
        ]; 

        this.state = {
            data: props.data,
            messageBox: null
            //modalType: 0,
            //modalMsg: "",
            //msgNumber: 0
        };
    }

    //#region Events

    componentDidMount() {
        ajax(this, { method: 'get', url: '/api/organization/label-setts', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                let resp = response.data.result.labelSettings; //setEmptyStrings(response.data.result.labelSettings);
                if (!resp.defaultLabel) {
                    resp.defaultLabel = this.labelFormats[0].value;
                }
                this.setState({ data: resp });
            },
            error => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[0].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                    </UIMessageBox>
                });
            }
        );
    }

    dataChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        let newData = JSON.parse(JSON.stringify(this.state.data));
        newData[name] = value;
        this.setState({ data: newData });
    }

    actionClick(ev) {
        ajax(this, { method: 'post', url: '/api/organization/label-setts', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: this.state.data },
            response => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[1].captions[0]} message={this.le.messages[1].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[1].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                    </UIMessageBox>
                });
            },
            error => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[0].button} onClick={(ev) => { this.setState({ messageBox: null }); }} />
                    </UIMessageBox>
                });
            }
        );
    }

    /*closeModal(ev) {
        this.setState({ modalType: 0, modalMsg: "" });
    }*/

    //#endregion Events

    render() {
        //#region Data Structures
        /*const items = this.le.sections.map(el => {
            let rows = [<UTitle key={"title-" + el.id} textClass="upper bold" text={el.title} />];
            rows.push(<div key={"sepa-1-" + el.id} style={{ marginTop: "1rem", borderTop: "2px solid #d3d3d3", marginBottom: "2rem" }} />);
            const cols = el.items.map(itm => (
                <div key={el.id + "-" + itm.name} className="col-5">
                    <UInput name={el.id + "." + itm.name} rowClass="u-lift no-margin" value={this.state.data[itm.name]} pholder={itm.text} onChange={this.dataChange} />
                </div>
            ), this);
            rows.push(<div key={el.id} className="row">{cols}</div>);
            return rows;
        }, this);*/
        //#endregion Data Structures

        /*
        let modal = null;
        if (this.state.modalType > 0) {
            const msg = this.le.messages[this.state.modalType - 1];
            const data = {
                captions: msg.captions,
                messages: [this.state.modalMsg || msg.messages[this.state.msgNumber]],
                buttons: [{ text: msg.button, click: this.closeModal }]
            };
            modal = (<MessageBox width="40%" data={data} />);
        }*/



        const widgets = this.le.sections.map((el, idx) => {
            return [
                <div key={"tit-" + idx} className="widget-content-title">{el.title}</div>,
                <div key={"inp-" + idx} className="input-panel">
                    {
                        el.items.map(itm => {
                            if (itm.name == 'defaultLabel') {
                                return <UISelect key={el.id + "-" + itm.name} name={itm.name} value={this.state.data[itm.name]} label={itm.text} onChange={this.dataChange} error={itm.error} options={this.labelFormats}/>
                            }
                            else {
                                return <UIInput key={el.id + "-" + itm.name} name={itm.name} value={this.state.data[itm.name]} label={itm.text} onChange={this.dataChange} error={itm.error} />
                            }

                        }, this)
                    }
                </div>
            ]
        }, this);

        return <div className="page-packageconfig">
            <PageTitle icon="../images/mainMenu/Settings.png" title={Languages.getSection('Main').menuLabels.labels} />
            <div className="page-content">
                <div className="widget">
                    <div className="widget-content">
                        {widgets}
                        <UIButtonPad align="right">
                            <UIButton className="confirm slim" text={this.le.buttons[0]} onClick={this.actionClick} />
                        </UIButtonPad>
                    </div>
                </div>
            </div>
            {this.state.messageBox}
        </div>;






       /* return (
            <div id={this.constructor.name}>
                <SettingsBasePage title={this.le.title} description={this.le.description}>
                    {items}
                    <UButtonGroup>
                        <UButton extraClass="thin" type="confirm" text={this.le.buttons[0]} onClick={this.actionClick} />
                    </UButtonGroup>
                </SettingsBasePage>
                {modal}
            </div>
        );*/
    }
}

export class PackageConfig extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        this.dataChange = this.dataChange.bind(this);
        this.createPackageSection = this.createPackageSection.bind(this);
        this.showPackageConfigPopup = this.showPackageConfigPopup.bind(this);
        this.closePackageConfigModal = this.closePackageConfigModal.bind(this);
        this.onToggleDefaultPackageSection = this.onToggleDefaultPackageSection.bind(this);
        this.onEditPackageSection = this.onEditPackageSection.bind(this);
        this.onRemovePackageSection = this.onRemovePackageSection.bind(this);
        this.updatePackageSection = this.updatePackageSection.bind(this);
        //#endregion Methods binding
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.le = Languages.PackageConfig[Languages.selectedLanguage];

        this.state = {
            data: props.data,
            packageItems: [],
            modalType: 0,
            modalMsg: "",
            msgNumber: 0,
            modalError: {},
            modalTarget: ''
        };
    }

    //#region Events

    componentDidMount() {
        ajax(this, { method: 'get', url: '/api/organization/package-config', headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            response => {
                let configPackageItems = setEmptyStrings(response.data.result.packageConfig);
                this.setState({ packageItems: configPackageItems });
            },
            () => {
                //this.setState({ modalType: 1, modalMsg: error.message });
              this.setErrorState();
            }
        );
    }

    setErrorState() {
        this.setState({
            messageBox: <UIMessageBox type="info" title={this.le.messages[0].captions[0]} message={this.le.messages[0].messages[0]}>
                <UIButton className="confirm"
                    text={this.le.messages[0].button}
                    onClick={() => {
                         this.setState({
                            messageBox: null,
                            modalTarget: '',
                            data: { name: '', weight: '', length: '', height: '', depth: '' }
                         });}} />
            </UIMessageBox>
        });
    }

    validatePackageSection() {
        let validationData = [];
        this.le.sections.map((el, idx) => {
            el.items.map(itm => {
                if(itm.name === 'name') {
                    validationData.push({
                        fieldObject: itm,
                        fieldName: itm.name,
                        fieldValue: this.state.data[itm.name],
                        fieldError: 'error',
                        validate: emptyValidation
                    })
                } else {
                    validationData.push({
                        fieldObject: itm,
                        fieldName: itm.name,
                        fieldValue: this.state.data[itm.name],
                        fieldError: 'error',
                        validate: numberValidation
                    })
                }
            }, this)
        });

        return validationData;

    }

    dataChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        let newData = {...this.state.data};
        newData[name] = value;
        this.setState({ data: newData });

    }

    showPackageConfigPopup(modalTarget) {
        this.setState({
            modalTarget: modalTarget
        });
    }

    closePackageConfigModal() {
        this.setState({
            modalTarget: '',
            data: { name: '',id: '', weight: '', length: '', height: '', depth: '' }
        });
    }

    onEditPackageSection(packageItemData) {
        this.setState({
            data: packageItemData,
            modalTarget: 'editConfigPackage'
        });
    }

    setDefaultPackageSectionState(packageSectionId) {
        this.setState(prevState => {
            const packageItemsState = [...prevState.packageItems];
            const allPackagesReset = packageItemsState.map(item => {
               if(item.default) {
                    return {
                        ...item,
                        default: false
                    }
               }
               else if(item.id === packageSectionId) {
                    return {
                        ...item,
                        default: true
                    }
               }
               return {
                    ...item,
               }
            });

            const foundPackageSection = allPackagesReset.find((item) => item.id === packageSectionId);
            const packageSectionIndex = allPackagesReset.findIndex((item) => item.id === packageSectionId);
    
            const updatedPackageSection = {
                ...foundPackageSection,
            }
    
            allPackagesReset[packageSectionIndex] = updatedPackageSection;

            return {
                messageBox: null,
                modalTarget: '',
                packageItems: allPackagesReset
            }
        })
    }

    onToggleDefaultPackageSection(packageSectionId) {
        ajax(this, { method: 'post', url: `/api/organization/default-package-config/${packageSectionId}`, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
        () => {
            this.setDefaultPackageSectionState(packageSectionId);
            // this.setState({
            //     messageBox: <UIMessageBox type="info" title={this.le.messages[1].captions[0]} message={this.le.messages[1].messages[0]}>
            //         <UIButton className="confirm"
            //          text={this.le.messages[1].button}
            //          onClick={this.setDefaultPackageSectionState.bind(this, packageSectionId)} />
            //     </UIMessageBox>
            // });
        },
        () => {
          this.setErrorState();
        }
    );

        
    }

    onRemovePackageSection(packageSectionId) {
        ajax(this, { method: 'post', url: `/api/organization/package-config-delete/${packageSectionId}`, headers: { Authorization: 'Bearer ' + this.uc.jwtToken } },
            () => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[1].captions[0]} message={this.le.messages[1].messages[0]}>
                        <UIButton className="confirm"
                         text={this.le.messages[1].button}
                          onClick={() => {
                                const filteredItems = [...this.state.packageItems].filter((item) => item.id !== packageSectionId);
                                this.setState({ 
                                    messageBox: null,
                                    modalTarget: '',
                                    packageItems: filteredItems,
                                    data: { name: '', weight: '', length: '', height: '', depth: '' 
                            }}); }} />
                    </UIMessageBox>
                });
            },
            () => {
                this.setErrorState();
            }
        );
    }

    createPackageSection() {
        const validationData = this.validatePackageSection();

        if (!validate(validationData)) {
            this.props.popupErrorMessage(this.le.messages[2].messages[0]);
            return;
        }

        const newState = [...this.state.packageItems];
        const newPackage = {
            id: uuidv4(),
            default: false,
            ...this.state.data
        }

        newState.push(newPackage);

        ajax(this, { method: 'post', url: '/api/organization/package-config', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: newPackage },
            () => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[1].captions[0]} message={this.le.messages[1].messages[0]}>
                        <UIButton className="confirm" text={this.le.messages[1].button} onClick={() => { this.setState({ messageBox: null, modalTarget: '', packageItems: newState, data: { name: '', weight: '', length: '', height: '', depth: '' }}); }} />
                    </UIMessageBox>
                });
            },
            () => {
              this.setErrorState();
            }
        );
    }

    updatePackageSection() {
        const validationData = this.validatePackageSection();

        if (!validate(validationData)) {
            this.props.popupErrorMessage(this.le.messages[2].messages[0]);
            return;
        }

        const packageDataEdit = {...this.state.data};
        const packageItems = [...this.state.packageItems];

        const packageSectionIndex = packageItems.findIndex((item) => item.id === packageDataEdit.id);
    
        const updatedPackageSection = {
            ...packageDataEdit,
        }

        packageItems[packageSectionIndex] = updatedPackageSection;

        ajax(this, { method: 'post', url: '/api/organization/package-config', headers: { Authorization: 'Bearer ' + this.uc.jwtToken }, data: updatedPackageSection },
            () => {
                this.setState({
                    messageBox: <UIMessageBox type="info" title={this.le.messages[1].captions[0]} message={this.le.messages[1].messages[0]}>
                        <UIButton className="confirm"
                         text={this.le.messages[1].button}
                         onClick={() => {
                            this.setState({
                                messageBox: null,
                                packageItems: packageItems,
                                data: { name: '', weight: '', length: '', height: '', depth: '' },
                                modalTarget: '',
                            }); 
                        }} />
                    </UIMessageBox>
                });
            },
            () => {
              this.setErrorState();
            }
        );
    }

    //#endregion Events

    render() {
        const widgets = this.le.sections.map((el,idx) => {
            return [
                <div key={"inp-" + idx} className="input-panel"> {
                    el.items.map((itm, index) => {
                            return <UIInput
                                className={index === 0 ? 'input-100': 'input-50'}
                                key={el.id + "-" + itm.name} 
                                name={itm.name}
                                value={this.state.data[itm.name]}
                                label={itm.text} 
                                onChange={this.dataChange}
                                error={itm.error}/>
                    }, this)
                }
                </div>
            ]
        }, this);

        let popup = null;

        const packageItems = this.state.packageItems.map((packageItem, packageSectionIndex) => {
                return  (
                    <div key={packageSectionIndex} className="widget">
                            <div className="widget-content package-section">
                                <div className="package-section-setings">
                                    <div className="package-section-name">{packageItem.name}</div>
                                    <div className="package-section-controls-button">
                                        <div
                                            className={["package-section-fav", packageItem.default ? "package-section-fav-active": ""].join(' ')}
                                            onClick={() => this.onToggleDefaultPackageSection(packageItem.id)}>
                                            {/* <img src={FavIcon} /> */}
                                            <p>{this.le.packageControls.default}</p>
                                        </div>
                                        <div className="package-section-edit" onClick={() => this.onEditPackageSection(packageItem)}>
                                            {/* <img src={EditIcon} /> */}
                                            <p>{this.le.packageControls.edit}</p>
                                        </div>

                                        <div className="package-section-remove" onClick={() => this.onRemovePackageSection(packageItem.id)}>
                                            {/* <img src={RemoveIcon} /> */}
                                            <p>{this.le.packageControls.delete}</p>
                                        </div>
                                    </div>
                                </div>
                                <div  className="config-section"> {
                                    this.le.packageItems.map((itm) => {
                                            return <UIInput
                                                readOnly
                                                className='input-small input-white'
                                                key={uuidv4() + "-" + itm.name} 
                                                name={itm.name}
                                                value={this.state.packageItems[packageSectionIndex][itm.name]}
                                                label={itm.longText} 
                                                onChange={this.dataChange}
                                                error={itm.error}/>
                                    }, this)
                                }
                            </div>
                        </div>
                 </div>
                )
        }, this)
        
        if (this.state.modalTarget == 'addConfigPackage') {
            popup = <UIPopup
                className="add-config-package"
                title={this.le.titles[0]}
                onCancel={this.closePackageConfigModal}>
                {widgets}
                <UIButtonPad className="center">
                    <UIButton className="confirm slim add-new-package" text={this.le.buttons[0]} onClick={this.createPackageSection} />
                </UIButtonPad>
            </UIPopup>;
        }


        if (this.state.modalTarget == 'editConfigPackage') {
            popup = <UIPopup
                className="edit-config-package"
                title={this.le.titles[0]}
                onCancel={this.closePackageConfigModal}>
                {widgets}
                <UIButtonPad className="center">
                    <UIButton className="confirm slim edit-package" text={this.le.buttons[0]} onClick={this.updatePackageSection} />
                </UIButtonPad>
            </UIPopup>;
        }


        return <div className="page-packageconfig">
            <PageTitle icon="../images/mainMenu/Settings.png" title={Languages.getSection('Main').menuLabels.package}/>
            <div className={'page-content grid-2'}>
                {packageItems}
                {<AddConfig  onClick={this.showPackageConfigPopup.bind(this, 'addConfigPackage')} buttonText={this.le.buttonText} className='add-package-button' />}
                {popup}
            </div>
          
            {this.state.messageBox}
        </div>;
    }
}

export class Notifications extends React.Component {
    constructor(props) {
        super(props);

        //#region Methods binding
        this.actionClick = this.actionClick.bind(this);
        this.editClick = this.editClick.bind(this);
        //#endregion Methods binding

        this.le = Languages.Notifications[Languages.selectedLanguage];
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.state = {
            data: props.data
        };
    }


    componentDidMount() {
        loadUserSettings("emailNotifications", this.uc.jwtToken,
            settings => {
                this.setState({ data: settings });
            },
            ko => {


            });
    }


    //#region Events
    actionClick(ev, name) {
        try {

            this.props.loaderShow(0);

            postUserSettings("emailNotifications", this.state.data, this.uc.jwtToken,
                ok => {

                    this.props.loaderHide();
                    let obj = {
                        title: this.le.messages.ok.title[0],
                        icon: this.le.messages.ok.icon,
                        messages: this.le.messages.ok.message,
                        buttons: [{ name: "ok", type: "confirm", text: this.le.messages.ok.button, click: null }]
                    };
                    this.props.popupMessage(obj);

                },
                ko => {
                    this.props.loaderHide();

                    this.props.popupErrorMessage("");

                    //showAlertPopup(this.props.popupMessage, this.le.messages.error, ok => { });
                });

        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    editClick(ev, name) {

        try {

            const names = name.split(".");
            if (names[2] === "edit") {
                let newData = JSON.parse(JSON.stringify(this.state.data));
                newData[names[1]] = !newData[names[1]];
                this.setState({ data: newData });
            }
            else {

                const names = name.split(".");
                this.props.loaderShow(0);
                checkUserSettingsEmail(names[1], this.uc.jwtToken,
                    (emailSent) => {

                        this.props.loaderHide();
                        const msg = this.le.messages.mailInviata;
                        let obj = {
                            title: msg.title,
                            width: "35%",
                            icon: "info",
                            messages: [msg.message + emailSent],
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                        };
                        this.props.popupMessage(obj);
                    },
                    (error) => {

                        this.props.loaderHide();
                        const msg = this.le.messages.error;
                        /*let obj = {
                            title: msg.title,
                            width: "35%",
                            icon: "error",
                            messages: error != undefined && error != null && error.hasOwnProperty("errorMessage") ? [error.errorMessage] :
                                msg.message,
                            buttons: [{ name: "ok", type: "confirm", width: "40%", text: "ok", class: "right", click: null }]
                        };
                        this.props.popupMessage(obj);*/



                        let messages = error != undefined && error != null && error.hasOwnProperty("errorMessage") ? [error.errorMessage] : msg.message;
                        this.props.popupErrorMessage(messages);

                    });



            }
        }
        catch (e) {
            this.props.loaderHide();
        }
    }

    //#endregion Events

    render() {
        //#region Data Structures
        const widgets = this.le.sections.map((el, elIdx) => {

            const blocks = el.items.map(itm => {
                const status = this.state.data[itm.name];

                return [<div className="entry-list-row-panel">
                    <div className="entry-list-text">
                        {itm.text}
                        <br />
                        <ULinkFlat onClick={(ev) => this.editClick(ev, el.id + "." + itm.name + ".action")} text={el.action}/>
                    </div>
                </div>,
                <div className="entry-list-row-panel">
                </div>,
                <div className="entry-list-row-panel">
                    <div className={"entry-list-status " + (status ? '' : 'off')} onClick={(ev) => this.editClick(ev, el.id + "." + itm.name + ".edit")}></div>
                    <div className="entry-list-text">{status ? el.active : el.inactive}</div>
                </div>];
            }, this);

            return <div className="widget" key={el.id}>
                <div className="widget-header">
                    {el.description}
                </div>
                <div className="widget-content for-entry-list">
                    <div className="entry-list" key={"entry-" + el.id}>

                        <div className="entry-list-row-panel entry-list-row-header">
                            <div>{el.title}</div>
                        </div>
                        <div className="entry-list-row-panel entry-list-row-header">
                        </div>
                        <div className="entry-list-row-panel entry-list-row-header">
                            <div />
                            <div className="">{el.status}</div>
                        </div>
                        {blocks}
                    </div>
                    <UIButtonPad align="right">
                        <UIButton className="confirm slim" text={this.le.buttons[0]} onClick={this.actionClick} />
                    </UIButtonPad>
                </div>
            </div>;
        }, this);
        //#endregion Data Structures

        return <div className="page-notifications">
            <PageTitle icon="../images/mainMenu/Notifications.png" title={Languages.getSection('Main').menuLabels.notifications} />
            <div className="page-content">
                {widgets}
            </div>

        </div>;
    }
}